module.exports = __webpack_public_path__ + "img/xianlai_logo.f2b80f45.png";